module.exports = __webpack_public_path__ + "static/media/Palpitoad_gaussian2.37e4bd4a.png";